import { render, staticRenderFns } from "./PrintOrderSuppliers.vue?vue&type=template&id=33ee29dc"
import script from "./PrintOrderSuppliers.vue?vue&type=script&lang=js"
export * from "./PrintOrderSuppliers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports